import { createRouter, createWebHistory } from "vue-router";
import Home from "../views/Home.vue";
import PrivacyPolicy from "@/views/PrivacyPolicy";
import TermsOfUse from "@/views/TermsOfUse";

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home
  },
  {
    path: "/privacy_policy",
    name: "PrivacyPolicy",
    component: PrivacyPolicy
  },
  {
    path: "/terms_of_use",
    name: "TermsOfUse",
    component: TermsOfUse
  }
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
});

export default router;
